import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import { Stack, Typography } from "@mui/material";

import type { TabularDataCell } from "../../../../../../../api/types/svTypes.ts";

interface Props {
  delta: TabularDataCell;
}

const TileDelta = ({ delta }: Props) => {
  const isDeltaPositive = delta && (delta.value as number) >= 0;
  const color = isDeltaPositive ? "success" : "error";
  const Icon = isDeltaPositive ? ArrowUpwardRoundedIcon : ArrowDownwardRoundedIcon;

  return (
    <Stack direction="row" useFlexGap spacing={0.5} sx={{ alignItems: "end" }}>
      <Icon color={color} />
      <Typography color={color}>{delta?.formattedValue}</Typography>
    </Stack>
  );
};

export default TileDelta;
